import axios from 'axios';
import {
  buildReadOnlyError,
  notifyReadOnlyBlocked,
  shouldBlockMutation,
} from '../utils/roleUtils';

// Buat instance Axios dengan konfigurasi default
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BE_PROD_BASE_URL, // Ubah sesuai dengan base URL API Anda
  // Anda dapat menambahkan konfigurasi lain di sini
});

// Jika Anda ingin menambahkan header default, contohnya:
axiosInstance.defaults.headers.common['Authorization'] =
  'Bearer ' + localStorage.getItem('tokenAuth');

// Request interceptor: blok mutasi (POST/PUT/PATCH/DELETE) untuk admin
// read-only sebelum sampai ke jaringan. Menangkap juga jalur "inline
// axiosInstance.post(...)" yang tidak lewat ApiService.
axiosInstance.interceptors.request.use((config) => {
  const method = (config.method || 'get').toString();
  const url = config.url || '';
  if (shouldBlockMutation(method, url)) {
    notifyReadOnlyBlocked();
    return Promise.reject(buildReadOnlyError(config));
  }
  return config;
});

// Response interceptor: kalau backend mengembalikan 403 dengan kode
// READONLY_ADMIN (atau pesan serupa), biarkan caller meng-handle —
// pesan toast dapat diseragamkan di sini bila diperlukan di masa depan.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default axiosInstance;
